import { createReducer, on, State, Action } from '@ngrx/store';
import { IJobPosition } from '@shared/interfaces/job-position.interface';
import { uploadJobPositions, listJobPositionsSuccess, listJobPositionsError } from '@store/actions';

export interface JobPositionsState {
  jobs: IJobPosition[];
  loaded: boolean;
  loading: boolean;
  error: any;
}

export const jobPositionsInitialState: JobPositionsState = {
  jobs: [],
  loaded: false,
  loading: false,
  error: null,
};

const _jobPositionsReducer = createReducer(
  jobPositionsInitialState,
  // Disparar la acción y poner el louded en true para mostrar al usuario un aviso por pantalla
  on(uploadJobPositions, (state) => ({ ...state, loading: true })),

  // Cargar los usuarios
  on(listJobPositionsSuccess, (state, { jobPositions }) => ({
    ...state,
    loading: false,
    loaded: true,
    jobs: [...jobPositions],
  })),

  // Se dispara para mostar el error si la operación de cargar usuarios falla
  on(listJobPositionsError, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),
);
export function jobPositionsReducer(state, action: Action) {
  return _jobPositionsReducer(state, action);
}
//TODO: comentar
